import { type HTMLAttributes } from 'react';
import classnames from 'classnames';
import styles from './SidebarAwareContainer.module.scss';

type TSidebarAwareContainerProps = HTMLAttributes<HTMLDivElement>;

export default function SidebarAwareContainer({
  children,
  className,
  ...rest
}: TSidebarAwareContainerProps) {
  return (
    <div className={classnames(styles.container, className)} {...rest}>
      {children}
    </div>
  );
}
